// extracted by mini-css-extract-plugin
module.exports = {"videoSection":"YoutubeVideoSection_videoSection__xGwOn"};